import { Component, ElementRef, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Empty_ExpertCalibration_Interface, ExpertCalibration_Interface } from 'src/app/Interface/ExpertCalibration_Interface';
import { Empty_General_Interface, General_Interface } from 'src/app/Interface/General_Interface';
import { Empty_Lab_Interface, Lab_Interface } from 'src/app/Interface/Lab_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CalibrationService } from 'src/app/Service/Calibration/Calibration.service';
import { ExpertCalibrationService } from 'src/app/Service/ExpertCalibration/ExpertCalibration.service';
import { LabService } from 'src/app/Service/Lab/Lab.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-LabDownloadUploadDevice',
  templateUrl: './LabDownloadUploadDevice.component.html',
  styleUrls: ['./LabDownloadUploadDevice.component.scss']
})
export class LabDownloadUploadDeviceComponent implements OnInit {
  QRCodeInput: string = ""
  QRCodeInput_Controller: number = 0
  Dsc_Exit: String = ""
  page: number = 0;
  Procssing: boolean = false;
  InProccessing: boolean = false;
  modalRef_Download: any;
  modalRef_Upload: any;
  modalRef_Exit: any;

  DataList_Lab: Array<Lab_Interface> = []
  constructor(
    private Lab_Service: LabService,
    private Calibration_Service: CalibrationService,
    private ExpertCalibration_Service: ExpertCalibrationService,
    private Alertify_Service: AlertifyService,
    private Nav_Service: NavService,
    private modalService: BsModalService
  ) { }

  ngOnInit() {
    this.Nav_Service.CheckValidPage(8).subscribe(
      data => {
        this.Read_GetDetailCount()
      }
      , error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }

  current_Month_DownloadLab: number = 0
  current_Year_DownloadLab: number = 0
  last_Month_DownloadLab: number = 0
  last_Year_DownloadLab: number = 0

  current_Year_UploadLab: number = 0
  current_Month_UploadLab: number = 0
  last_Month_UploadLab: number = 0
  last_Year_UploadLab: number = 0

  current_Year_UploadLab_Late: number = 0
  current_Month_UploadLab_Late: number = 0
  last_Month_UploadLab_Late: number = 0
  last_Year_UploadLab_Late: number = 0


  waitedDevice: number = 0
  waitedexitedDevice: number = 0

  Read_GetDetailCount() {
    this.Lab_Service.GetDetailCount().subscribe(
      data => {
        this.current_Month_DownloadLab = data['current_Month_DownloadLab']
        this.current_Year_DownloadLab = data['current_Year_DownloadLab']
        this.last_Month_DownloadLab = data['last_Month_DownloadLab']
        this.last_Year_DownloadLab = data['last_Year_DownloadLab']

        this.current_Month_UploadLab = data['current_Month_UploadLab']
        this.current_Year_UploadLab = data['current_Year_UploadLab']
        this.last_Month_UploadLab = data['last_Month_UploadLab']
        this.last_Year_UploadLab = data['last_Year_UploadLab']

        this.current_Month_UploadLab_Late = data['current_Month_UploadLab_Late']
        this.current_Year_UploadLab_Late = data['current_Year_UploadLab_Late']
        this.last_Month_UploadLab_Late = data['last_Month_UploadLab_Late']
        this.last_Year_UploadLab_Late = data['last_Year_UploadLab_Late']

        this.waitedDevice = data['waitedDevice']
        this.waitedexitedDevice = data['waitedexitedDevice']
        this.ReadData_ExpertCalibration()

      }
    )
  }

  openModalExit(template: TemplateRef<any>) {
    this.modalRef_Exit = this.modalService.show(template);
    this.QRCodeInput = ""
    this.Dsc_Exit = ""
  }

  Filter_customer: String = ''
  Filter_Type_Lap: String = '0'

  SubmitPeriodDate_ReceiveDate: string = '1'
  SubmitPeriodDate_DownloadDate: string = '0'
  SubmitPeriodDate_UploadDate: string = '0'


  ReadData_Lab(StartSearchDate_ReceiveDate, EndSearchDate_ReceiveDate, StartSearchDate_DownloadDate, EndSearchDate_DownloadDate, StartSearchDate_UploadDate, EndSearchDate_UploadDate) {
    this.Procssing = true
    this.DataList_Lab = []



    this.Lab_Service.Get(
      StartSearchDate_ReceiveDate,
      EndSearchDate_ReceiveDate,

      StartSearchDate_DownloadDate,
      EndSearchDate_DownloadDate,

      StartSearchDate_UploadDate,
      EndSearchDate_UploadDate,

      Number(this.SubmitPeriodDate_ReceiveDate),
      Number(this.SubmitPeriodDate_DownloadDate),
      Number(this.SubmitPeriodDate_UploadDate),

      this.Filter_customer,
      Number(this.Filter_Type_Lap)).subscribe(
      data => {
        this.DataList_Lab = data
        this.Procssing = false


      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }




  QRCodeChangeExit() {
    this.InProccessing = true
    this.Lab_Service.PostExit(this.QRCodeInput, this.Dsc_Exit).subscribe(
      data => {
        this.InProccessing = false
        this.QRCodeInput = ""
        this.Dsc_Exit = ""
        if (data.id == 0) {
          this.Alertify_Service.ErrorMessage(data.dsc)
        }
        else {
          this.Alertify_Service.SuccessMessage("ثبت شد")
          this.Read_GetDetailCount()
        }
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )


  }




  exportexcel(): void {
    /* table id is passed over here */
    let element = document.getElementById('excel-table');
    const ws: XLSX.WorkSheet = XLSX.utils.table_to_sheet(element);

    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    /* save to file */
    XLSX.writeFile(wb, "BehfaLab.xlsx");

  }


  //#region Merge

  modalRef_ParentMerge: any
  modalRef_ParentMergeChild: any
  SelectedLab_Merge: Lab_Interface = Empty_Lab_Interface()
  SelectedLab_Merge_Merge: Lab_Interface = Empty_Lab_Interface()
  SelectedLab_Merge_Merge_Child: Array<Lab_Interface> = []
  MergeIndex: string = ""
  MergeCalibration() {
    if (!this.DataList_Lab[Number(this.MergeIndex) - 1]) {
      this.Alertify_Service.ErrorMessage("ردیف صحیح نمی باشد")
    }
    else {
      this.InProccessing = true
      this.Calibration_Service.MergeCalibration(this.SelectedLab_Merge.id,
        this.DataList_Lab[Number(this.MergeIndex) - 1].id).subscribe(
          data => {
            if (data['id'] == -1) {
              this.Alertify_Service.ErrorMessage("دستگاه مد نظر ثبت ورود شده است")
            }
            else {
              this.InProccessing = false
              this.DataList_Lab.splice(Number(this.MergeIndex)-1, 1)
              this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
              this.MergeIndex = ""
              this.SelectedLab_Merge_Merge = Empty_Lab_Interface()
            }
          }
        )
    }
  }

  UnMergeCalibration(item: Lab_Interface) {
    this.InProccessing = true
    this.modalRef_ParentMergeChild.hide()
    this.Calibration_Service.UnMergeCalibration(item.id).subscribe(
        data => {
          if (data['id'] == -1) {
            this.Alertify_Service.ErrorMessage("دستگاه مد نظر ثبت ورود شده است")
          }
          else {
            this.InProccessing = false
            this.SelectedLab_Merge_Merge_Child.splice(this.SelectedLab_Merge_Merge_Child.indexOf(item), 1)
            this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
            this.MergeIndex = ""
            
          }
        }
      )
  }

  MergeIndexKeyUp() {
    if (Number(this.MergeIndex) > this.DataList_Lab.length)
      this.Alertify_Service.ErrorMessage("محدوده در لیست نمی باشد")
    else {
      this.SelectedLab_Merge_Merge = this.DataList_Lab[Number(this.MergeIndex) - 1]
    }
  }

  openModalParentMerge(template: TemplateRef<any>, item: Lab_Interface) {
    this.modalRef_ParentMerge = this.modalService.show(template);
    this.MergeIndex = ""
    this.SelectedLab_Merge_Merge = Empty_Lab_Interface()
    this.SelectedLab_Merge = item
  }

  openModalParentMergeChild(template: TemplateRef<any>, item: Array<Lab_Interface>) {
    this.modalRef_ParentMergeChild = this.modalService.show(template);

    this.SelectedLab_Merge_Merge_Child = item
  }


  //#endregion


  //#region  کارشناس کالیبراسیون
  modalRef_ExpertCalibration: any;
  Procssing_ExpertCalibration: boolean = false

  Selected_Record_Edit_ExpertCalibration: number = -1

  openModal_ExpertCalibration(template: TemplateRef<any>, ExpertCalibration_Indexer: number) {
    this.modalRef_ExpertCalibration = this.modalService.show(template);
    this.Selected_Record_Edit_ExpertCalibration = ExpertCalibration_Indexer
  }

  ExpertCalibrationpage: number = 0;
  Filter_Familly: string = ''
  Filter_Area: string = ''

  Change_Filter() {
    this.ExpertCalibrationpage = 0
  }

  ReadData_ExpertCalibration() {
    this.Procssing_ExpertCalibration = true

    this.ExpertCalibration_Service.GetActiveList(true, false, true).subscribe(
      data => {
        this.DataList_ExpertCalibration = data
        this.Procssing_ExpertCalibration = false
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  Data_Seleted_ExpertCalibration: ExpertCalibration_Interface = Empty_ExpertCalibration_Interface()
  DataList_ExpertCalibration: Array<ExpertCalibration_Interface> = []

  Set_Selected_ExpertCalibration_Record(item) {
    this.modalRef_ExpertCalibration.hide()
    if (this.Selected_Record_Edit_ExpertCalibration == -1) {
      this.Data_Seleted_ExpertCalibration = item
    }
    else {
      this.Procssing = true
      this.DataList_Lab[this.Selected_Record_Edit_ExpertCalibration].Processing = true
      this.Calibration_Service.EditExpertCalibration(this.DataList_Lab[this.Selected_Record_Edit_ExpertCalibration].id, item.id).subscribe(
        data => {
          this.Procssing = false
          this.DataList_Lab[this.Selected_Record_Edit_ExpertCalibration].Processing = false
          this.DataList_Lab[this.Selected_Record_Edit_ExpertCalibration].expert_Calibration = data['name']
          this.Alertify_Service.SuccessMessage("ویرایش کارشناس کالیبراسیون اعمال شد")
        }, error => {
          // AuthInterceptor owns authentication; feature errors must preserve credentials.

        }
      )
    }
  }

  //#endregion


}
